module.exports = __webpack_public_path__ + "img/hamburger.a24929ec.png";